import type { AxiosInstance } from 'axios'

import {
  BlogDetailInterface,
  UpdateBlogInputInterface
} from '../../interfaces/blog'

export const updateBlog = (api: AxiosInstance) => (
  blogId: string,
  blogDetail: UpdateBlogInputInterface
): Promise<BlogDetailInterface> =>
  api.put(`/v1.0/admin/blogs/${blogId}`, blogDetail)
